module.exports = __webpack_public_path__ + "img/tail-spin-white.e095237a.svg";